import { Button } from "@/components/ui/button";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import { scrollToStart } from "@/service/scroll/scroll";

interface AtcMedGroupsPaginationProps {
  page: number;
  totalPages: number;
  totalItems: number;
  onPrevious: () => void;
  onNext: () => void;
  variant?: "default" | "compact" | "mobile";
}

export function AtcMedGroupsPagination({
  page,
  totalPages,
  totalItems,
  onPrevious,
  onNext,
  variant = "default",
}: AtcMedGroupsPaginationProps) {
  if (totalPages <= 1) return null;

  const handlePreviousClick = () => {
    scrollToStart();
    onPrevious();
  };

  const handleNextClick = () => {
    scrollToStart();
    onNext();
  };

  if (variant === "compact") {
    return (
      <div className="flex w-fit items-center justify-center gap-2">
        <Button
          variant="outline"
          size="icon"
          onClick={handlePreviousClick}
          disabled={page <= 1}
        >
          <ChevronLeftIcon size={14} />
        </Button>

        <span className="min-w-12 text-center text-xs font-medium text-gray-700">
          {page} / {totalPages}
        </span>

        <Button
          variant="outline"
          size="icon"
          onClick={handleNextClick}
          disabled={page >= totalPages}
        >
          <ChevronRightIcon size={14} />
        </Button>
      </div>
    );
  }

  if (variant === "mobile") {
    return (
      <div className="flex w-full items-center justify-between gap-2">
        <Button
          variant="outline"
          size="icon"
          onClick={handlePreviousClick}
          disabled={page <= 1}
          className="w-10"
        >
          <ChevronLeftIcon size={14} />
        </Button>

        <span className="flex-1 text-center text-xs font-medium text-gray-700">
          {page} / {totalPages}
        </span>

        <Button
          variant="outline"
          size="icon"
          onClick={handleNextClick}
          disabled={page >= totalPages}
          className="w-10"
        >
          <ChevronRightIcon size={14} />
        </Button>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between gap-2 pt-3">
      <Button
        variant="outline"
        size="sm"
        onClick={handlePreviousClick}
        disabled={page <= 1}
        className="gap-1"
      >
        <ChevronLeftIcon size={14} />
        Poprzednia
      </Button>

      <span className="text-xs text-gray-500">
        Strona{" "}
        <span className="font-medium text-gray-700">
          {page} / {totalPages}
        </span>
        <span className="ml-1 hidden sm:inline">&middot; {totalItems}</span>
      </span>

      <Button
        variant="outline"
        size="sm"
        onClick={handleNextClick}
        disabled={page >= totalPages}
        className="gap-1"
      >
        Następna
        <ChevronRightIcon size={14} />
      </Button>
    </div>
  );
}
